<a class="flex flex-row no-underline" (click)="onOpenProfilePage()">
    <mat-icon svgIcon="evida_mit_evida_profile"></mat-icon>
    <div class="hidden lg:flex flex-col">
        <mat-label class="small-header">Anders Andersen</mat-label>
        <small class="text-green">Min profil</small>
    </div>
</a>
